import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import 'moment/locale/es';
import { api_host } from '../../../common/globals/constants';

moment.locale('es');

/**
 * Hook personalizado para obtener datos de disponibilidad downtime global por paso.
 *
 * @param {Object} params - Parámetros del hook.
 * @param {URLSearchParams} params.urlParams - Parámetros de URL para la petición.
 * @param {string} params.fetchApi - Nombre del endpoint de la API a consultar.
 * @param {boolean} [params.enabled=true] - Si la consulta está habilitada.
 * @param {number|boolean} [params.refreshTime=false] - Intervalo de refresco en ms o false.
 *
 * @returns {Object} Resultado de useQuery con data, isLoading, error, isFetching.
 *
 * @author David Maldonado
 * (c) Servicios de Monitoreo S.A. - Santiago, Chile
 */
export const useFetchAvailabilityDowntimeGlobal = ({
  urlParams,
  fetchApi,
  enabled = true,
  refreshTime = false,
}) => {
  return useQuery({
    queryKey: ['availabilityDowntimeGlobal', fetchApi, urlParams.toString()],
    queryFn: async () => {
      const response = await fetch(
        `${api_host}/reporte/online/indicadores/${fetchApi}/?${urlParams.toString()}`
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    },
    enabled,
    gcTime: 0,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: refreshTime || false,
  });
};
